import { Component, NgZone, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { OnReadyDirective } from '@app/common-codes/components/directives/OnReadyDirective';
import { Visit } from '@app/common-codes/models/matwins-tenant/Visit.model';
import { NavigationService } from '@app/common-codes/services/navigation.service';
import { FieldWrapperComponent } from '@app/common-codes/components/nested-components/field-wrapper/field-wrapper.component';
import { PhotoCaptureComponent } from '../../photo/photo-capture.component';
import { CurrentTenantService } from '@app/common-codes/services/CurrentTenantService';
import { MultiSelectComponent } from '@app/common-codes/components/nested-components/multi-select/multi-select.component';
import { VISITOR_TYPES, VisitorType } from '../../ipad-visitor-type/ipad-visitor-type.component';
import { CheckinBaseComponent } from '../checkin-base.component';
import { CheckinShellComponent } from '../checkin-shell/checkin-shell.component';
import { EngagementViewerComponent } from "./engagement-viewer.component";
import { QuizViewerComponent } from "../quiz/quiz-viewer.component";
import { PolicyViewerComponent } from "../policy/policy-viewer.component";
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { HealthyViewerComponent } from "../healthy/healthy-viewer.component";

@Register(Visit)
@Component({
    selector: 'app-contractor-checkin',
    templateUrl: './contractor-checkin.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, TranslatePipe, OnReadyDirective, FieldWrapperComponent, PhotoCaptureComponent, MultiSelectComponent, CheckinShellComponent, EngagementViewerComponent, QuizViewerComponent, PolicyViewerComponent, HealthyViewerComponent]
})
export class ContractorCheckinComponent extends CheckinBaseComponent {

    visitorType: VisitorType | null = VISITOR_TYPES.find(vt => vt.key === 'contractor') ?? null;

    constructor(
        route: ActivatedRoute,
        router: Router,
        translationService: TranslationService,
        validationService: GenericValidationService,
        ngZone: NgZone,
        navService: NavigationService,
        tenantService: CurrentTenantService,
        alertModalService: AlertModalService

    ) {
        super(route, router, translationService, validationService, ngZone, navService, tenantService, alertModalService);
    }

    override getEmptyEntity(): Visit {
        const visit = super.getEmptyEntity();
        visit.visitorType = 2; // Contractor
        return visit;
    }

    protected override supportsEngagement = true;

    private fileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64 = (reader.result as string).split(',')[1];
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    override async performAfterSave(): Promise<void> {
        await super.performAfterSave();
        // TODO : sauvegarder le fichier dans fstreamimage et faire la liaison avec la visite
        const visit = this.editingEntity();
        if (!visit) return;

        const pos = this.tenantService.currentPointOfService();
        if (!pos) return;

        const signatureBase64 = visit.signatureFile
            ? await this.fileToBase64(visit.signatureFile)
            : null;
        if (signatureBase64) {
            const payload = {
                posId: pos.id,
                signatureBase64: signatureBase64,
                langKey: this.translationService.currentLanguage,
                visitId: visit.id
            };

            try {
                const result = await this.dataService.execute<boolean>('POST', 'generateEngagementReport', payload);
                if (result) {
                    if (result === true)
                        console.log('PDF generated successfully');
                    else
                        console.error('PDF generation failed');
                }
            } catch (err) {
                console.error('Erreur génération PDF:', err);
            }
        }
        // QUIZ report (après le bloc engagement)
        if (visit.quizStatus != null && visit.quizAnswers?.length) {
            const quizPayload = {
                posId: pos.id,
                signatureBase64: signatureBase64,
                langKey: this.translationService.currentLanguage,
                visitId: visit.id,
                answers: visit.quizAnswers
            };
            try {
                const result = await this.dataService.execute<boolean>('POST', 'generateQuizReport', quizPayload);
                if (result === true) console.log('Quiz PDF generated successfully');
                else console.error('Quiz PDF generation failed');
            } catch (err) {
                console.error('Erreur génération Quiz PDF:', err);
            }
        }
    }
}
